import React, { useEffect, useState } from 'react';
import { IconButton, Box, Typography, useTheme, Divider, Card, useMediaQuery, Menu, Tooltip } from '@mui/material';
import ColorLogo from './SVGIcons/SaagasColorLogo';
import AppsGrid from './SVGIcons/AppsGrid';
import HeaderMenu from './HeaderMenu';
import { useNavigate } from 'react-router-dom';

import { getActiveProfile, useApp } from '../context/AppContext';
import { useAppSelector } from '../../store/store';
import { useAccountBalance } from '../../hooks/useAccountBalance';
import usePricingPlans from '../../hooks/usePricingPlans';
import ChangePlanButton from '../profile/Billing.tsx/ChangePlan';
import InfoIcon from '../../icons/InfoIcon';
import PurchaseCreditsModel from '../profile/Billing.tsx/PurchaseCreditsModel';
import CoinsIcon from '../../assets/coinss.svg';
import SwitchProfileMenu from './SwitchProfileMenu';
import ExpandMoreIcon from '../../icons/ExpandMoreIcon';
import useUserDetails from '../../hooks/useUserDetails';
import BetaIcon from '../common/SVGIcons/BetaIcon';
// import { AppNotification } from './NotificationsMenu';
// import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

interface HeaderProps {
  isFixed?: boolean;
}

const Header: React.FC<HeaderProps> = ({ isFixed = true }) => {

  // const [notifications, setNotifications] = useState<Array<AppNotification>>([
  //   { id: 1, message: 'New comment on your post', date: '2m ago' },
  //   { id: 2, message: 'New follower request', date: '5m ago' },
  //   { id: 3, message: 'Profile updated successfully', date: '10m ago' },
  //   { id: 4, message: 'New like on your photo', date: '15m ago' }
  // ]);

  const theme = useTheme();
  const navigate = useNavigate();

  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [profileNavOpen, setNavMenuOpen] = useState(false);
  const { userInfo } = useApp();
  const [imageError, setImageError] = useState(false);
  const showFallback = imageError || !userInfo?.picture?.trim();

  // const [notificationsOpen, setNotificationsOpen] = useState(false);

  const handleProfileMenuOpen = () => setProfileMenuOpen(true);
  const handleNavMenuOpen = () => setNavMenuOpen(true);

  // const handleNotification = (notification: AppNotification) => {
  //   setNotifications(oldNotifications => oldNotifications.filter(n => n.id !== notification.id));
  // };

  const goToHome = () => {
    navigate(`/${getActiveProfile()}/dashboard`);
  };

  const { pricingPlans } = usePricingPlans();
  const { subscription } = useAppSelector(e => e.subscription);
  const [planPeriod] = useState('month');
  const { user } = useUserDetails();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);


  const { data: accountBalanceData } = useAccountBalance();


  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;

      if (Math.abs(currentScrollTop - lastScrollTop) > 35) {
        if (currentScrollTop > lastScrollTop) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
      }
    };

    const handleMouseMove = (e: { clientY: number }) => {
      if (e.clientY < 70) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [lastScrollTop]);


  const handleArrowClick = (event) => {
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <Box
      sx={{
        position: isFixed ? 'fixed' : '',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        height: isXsScreen ? "138px" : 56,
        borderBottom: `2px solid ${theme.palette.divider}`,
        backdropFilter: 'blur(20px)',
        paddingX: {
          xs: 2,
          sm: 4
        },
 
        background: theme.palette.mode === 'light' ? theme.palette.background.paper : undefined,
        paddingY: 1,
        zIndex: 996,
        transition: 'transform 0.5s ease',
        transform: isVisible ? 'translateY(0)' : 'translateY(-100%)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap'
        }}
      >
        {isXsScreen ?
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: 'column',width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: 4,
                  px: 1,
                  margin: "-30"

                }}
              >
                <IconButton onClick={goToHome} sx={{
                  width: "60px",
                  height: "32px"
                }}>
                  <ColorLogo />
                  <BetaIcon />
                </IconButton>

                <Typography
                  fontWeight="bold"
                  sx={{
                    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                    lineHeight: 'normal',

                    fontSize: {
                      md: 60,
                      sm: 46,
                      xs: "24px"
                    },
                    width: 'max-content',
                    textTransform: 'capitalize',
                    background: 'linear-gradient(90deg, #1CB0C8 0%, #FF3DA3 100%)',
                    backgroundclip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}
                >
                Hello, {user?.givenName + ''}!
                </Typography>
                <HeaderMenu open={profileMenuOpen} onOpenChange={setProfileMenuOpen} section="profile">
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      justifyContent: 'center',
                      alignContent: 'center'

                    }}
                  >

                    {!showFallback ? <Card
                      sx={{
                        background: theme.palette.background.default,
                        borderRadius: 50
                      }}
                      onClick={handleProfileMenuOpen}
                    >
                      <img
                        loading="lazy"
                        src={userInfo?.picture}
                        alt="User Profile"
                        onError={() => setImageError(true)}
                        style={{
                          width: 32,
                          height: 32,
                          cursor: 'pointer'
                        }}
                      />
                    </Card> :
                      <div className='w-[32px] h-[32px] bg-blue-500 rounded-full flex items-center justify-center'>
                        <span className='text-white font-medium'>
                          {userInfo?.givenName?.charAt(0)}
                        </span>
                      </div>}
                  </Box>
                </HeaderMenu>

              </Box>


              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%', width: '100%', alignSelf: "stretch" }}>
                <Box>
                  <HeaderMenu open={profileNavOpen} onOpenChange={setNavMenuOpen} section="app">

                    <Box
                      onClick={handleNavMenuOpen}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',

                        color: theme.palette.text.secondary,
                        cursor: 'pointer',
                        height: 32
                      }}
                    >
                      <IconButton>
                        <AppsGrid />
                      </IconButton>
                      <Typography
                        sx={{
                          display: isXsScreen ? 'none' : 'block'
                        }}
                      >
                      Menu
                      </Typography>
                    </Box>
                  </HeaderMenu>
                </Box>
                <Box sx={{ display: "flex", gap: "8px", right: "0px" }}>
                  <Box sx={{ display: 'flex', padding: "8px 12px" }}>


                    <Box className='text-sm flex items-center'>
                      <span className='flex items-center gap-2'>
                        <Box
                          component="img"
                          src={CoinsIcon}
                          sx={{
                            width: '24px',
                            height: '24px',
                            mb: '5px',
                          }}
                        />
                        <Box component="span" sx={{
                          fontFamily: 'Inter',
                          fontSize: { sm: '12px', md: '16px' }, fontWeight: 400, color: theme.palette.text.primary
                        }}>
                          {accountBalanceData?.total}
                        </Box>
                      </span>

                      <span className=" my-auto flex items-center md:ml-[10px]">
                        <IconButton onClick={handleArrowClick} >
                          <ExpandMoreIcon style={{
                            transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease',
                            width: 24,
                            height: 24,
                          }} />
                        </IconButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          aria-modal={false}
                          disableScrollLock={true}
                          sx={{
                            marginTop: '22px',
                            opacity: open ? 0 : 1,

                          }}
                          PaperProps={{
                            elevation: 1,
                            sx: {
                              backgroundColor: '#181818',
                              borderRadius: '8px',
                              padding: '2px',
                              margin: '3',
                              width: { xs: '90vw', sm: 'auto' },
                              left: { xs: '50%', sm: 'auto' },
                              transform: { xs: 'translateX(-50%)', sm: 'none' },
                              maxWidth: 'unset',
                            }
                          }}
                        >
                          <Typography
                            noWrap
                            sx={{
                              padding: '6px 6px',
                              fontSize: '14px',
                              color: theme.palette.text.primary,
                            }}
                          >
                          You currently have

                            {'   '}  {accountBalanceData?.total} {'   '}
                          credits
                          </Typography>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              paddingX: '8px',
                              gap: '12px',
                              width: '100%',
                              flexDirection: { xs: 'row', sm: 'row' }
                            }}
                          >

                            <ChangePlanButton
                              pricingPlans={pricingPlans} subscription={subscription} planPeriod={planPeriod} setOpen={setOpen} trigger={
                                <button className="py-2 w-full md:w-[10.5rem] my-4 text-center font-inter text-sm font-medium bg-[#1937E0] rounded-full flex items-center justify-center gap-2 px-4 whitespace-nowrap">
                                  <span className="font-inter text-sm font-medium"
                                  >Change Plans</span>
                                </button>} />

                            {subscription?.free ?
                              <Tooltip
                                title="Buy a plan to add credits"
                                placement="bottom"
                                arrow
                                sx={{
                                  zIndex: 9999
                                }}
                              >
                                <button
                                  className="py-2 w-full md:w-[10.5rem] my-4 text-center font-inter text-sm font-medium bg-[#393939] rounded-full flex items-center justify-center gap-2 px-4 whitespace-nowrap"
                                  style={{ marginLeft: 0 }}
                                >
                                  <span>Buy Credits</span>
                                  <InfoIcon className="size-5" />
                                </button>
                              </Tooltip> : <PurchaseCreditsModel
                                trigger={
                                  <button className="py-2 w-full md:w-[10.5rem] my-4 text-center font-inter text-sm font-medium  bg-[#1937E0] rounded-full flex items-center justify-center gap-2 px-4 whitespace-nowrap"
                                  >
                                    <span className="font-inter text-sm font-medium ">Buy Credits</span>
                                  </button>} />}

                          </Box>
                        </Menu>
                      </span>

                    </Box>
                  </Box>
                  <Box sx={{ padding: "12px" }}>
                  
                    <SwitchProfileMenu />
                  

                  </Box>

                </Box>
              </Box>
            </Box>
          </> :
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: isXsScreen ? 1 : 1,
                px: 0,

              }}
            >
              <IconButton
                onClick={goToHome}
                disableRipple
                sx={{
                  padding: 0, // optional: removes extra padding
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                  transition: "none", // disables smooth hover animation
                }}
              >
                <ColorLogo style={{ width: 32, height: 32, marginLeft: -15 }} />
                <BetaIcon style={{ width: 30, height: 30, marginTop: 13, marginLeft: -2 }} />
              </IconButton>


              {/*  */}

              <Divider
                orientation="vertical"
                sx={{
                  height: 50,
                  borderWidth: 1,
                  borderColor: theme.palette.divider
                }}
              />

              <HeaderMenu open={profileNavOpen} onOpenChange={setNavMenuOpen} section="app">

                <Box
                  onClick={handleNavMenuOpen}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: theme.palette.text.secondary,
                    cursor: 'pointer',
                    height: 20,
                  }}
                >
                  <IconButton>
                    <AppsGrid style={{ width: 17, height: 17 }} />
                  </IconButton>
                  <Typography
                    sx={{
                      display: isXsScreen ? 'none' : 'block',
                      fontSize: 14
                    }}
                  >
                    Menu 
                  </Typography>
                </Box>
              </HeaderMenu>
            </Box>


            <Box sx={{ display: 'flex', alignItems: 'center', gap: { sm: 1, md: 4 }, height: '100%' }}>

              {/* <NotificationsMenu open={notificationsOpen} onOpenChange={setNotificationsOpen} notifications={notifications} onNotification={handleNotification}>
            <IconButton aria-label="notifications" sx={{ height: 32 }}>
              <Badge
                badgeContent={notifications.length}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{
                  color: theme.custom.app.colors.end,
                  '& .MuiBadge-badge': {
                    minWidth: 10,
                    height: 14,
                    fontSize: '0.7rem',
                    border: `1px solid ${theme.custom.app.colors.end}`
                  }
                }}
              >
                <NotificationsNoneOutlinedIcon fontSize="inherit" sx={{ color: theme.custom.app.colors.start }} />
              </Badge>
            </IconButton>
          </NotificationsMenu> */}

              {/* <Divider
            orientation="vertical"
            sx={{
              height: 40,
              borderWidth: 1,
              borderColor: theme.palette.divider
            }}
          /> */}



              
              <SwitchProfileMenu />
              


              <Box className='text-sm flex items-center'>
                <span className='flex items-center gap-2'>
                  <Box
                    component="img"
                    src={CoinsIcon}
                    sx={{
                      width: '24px',
                      height: '24px',
                      mb: '5px',
                    }}
                  />
                  <Box component="span" sx={{
                    fontFamily: 'Inter',
                    fontSize: { sm: '12px', md: '16px' }, fontWeight: 400, color: theme.palette.text.primary
                  }}>
                    {accountBalanceData?.total}
                  </Box>
                </span>

                <span className=" my-auto flex items-center md:ml-[10px]">
                  <IconButton onClick={handleArrowClick} >
                    <ExpandMoreIcon style={{
                      transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease',
                      width: 24,
                      height: 24,
                    }} />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    aria-modal={false}
                    disableScrollLock={true}
                    sx={{
                      marginTop: '22px',
                      opacity: open ? 0 : 1,

                    }}
                    PaperProps={{
                      elevation: 1,
                      sx: {
                        backgroundColor: '#181818',
                        borderRadius: '8px',
                        padding: '2px',
                        margin: '3',
                        width: { xs: '90vw', sm: 'auto' },
                        left: { xs: '50%', sm: 'auto' },
                        transform: { xs: 'translateX(-50%)', sm: 'none' },
                        maxWidth: 'unset',
                      }
                    }}
                  >
                    <Typography
                      noWrap
                      sx={{
                        padding: '6px 6px',
                        fontSize: '14px',
                        color: theme.palette.text.primary,
                      }}
                    >
                      You currently have

                      {'   '}  {accountBalanceData?.total} {'   '}
                      credits
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingX: '8px',
                        gap: '12px',
                        width: '100%',
                        flexDirection: { xs: 'row', sm: 'row' }
                      }}
                    >

                      <ChangePlanButton
                        pricingPlans={pricingPlans} subscription={subscription} planPeriod={planPeriod} setOpen={setOpen} trigger={
                          <button className="py-2 w-full md:w-[10.5rem] my-4 text-center font-inter text-sm font-medium bg-[#1937E0] rounded-full flex items-center justify-center gap-2 px-4 whitespace-nowrap">
                            <span className="font-inter text-sm font-medium"
                            >Change Plans</span>
                          </button>} />

                      {subscription?.free ?
                        <Tooltip
                          title="Buy a plan to add credits"
                          placement="bottom"
                          arrow
                          sx={{
                            zIndex: 9999
                          }}
                        >
                          <button
                            className="py-2 w-full md:w-[10.5rem] my-4 text-center font-inter text-sm font-medium bg-[#393939] rounded-full flex items-center justify-center gap-2 px-4 whitespace-nowrap"
                            style={{ marginLeft: 0 }}
                          >
                            <span>Buy Credits</span>
                            <InfoIcon className="size-5" />
                          </button>
                        </Tooltip> : <PurchaseCreditsModel
                          trigger={
                            <button className="py-2 w-full md:w-[10.5rem] my-4 text-center font-inter text-sm font-medium  bg-[#1937E0] rounded-full flex items-center justify-center gap-2 px-4 whitespace-nowrap"
                            >
                              <span className="font-inter text-sm font-medium ">Buy Credits</span>
                            </button>} />}

                    </Box>
                  </Menu>
                </span>

              </Box>

              <HeaderMenu open={profileMenuOpen} onOpenChange={setProfileMenuOpen} section="profile">
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    justifyContent: 'center',
                    alignContent: 'center'
                  }}
                >

                  {!showFallback ? <Card
                    sx={{
                      background: theme.palette.background.default,
                      borderRadius: 50
                    }}
                    onClick={handleProfileMenuOpen}
                  >
                    <img
                      loading="lazy"
                      src={userInfo?.picture}
                      alt="User Profile"
                      onError={() => setImageError(true)}
                      style={{
                        width: 28,
                        height: 28,
                        cursor: 'pointer'
                      }}
                    />
                  </Card> :
                    <div className='w-9 h-9 bg-blue-500 rounded-full flex items-center justify-center'>
                      <span className='text-white font-medium'>
                        {userInfo?.givenName?.charAt(0)}
                      </span>
                    </div>}
                </Box>
              </HeaderMenu>

            </Box>
          </>}


      </Box>
    </Box >
  );
};

export default Header;

